import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';
import React, {useCallback} from 'react';
import {confirmable, createConfirmation} from 'react-confirm';
import Dialog from 'scenes/Dialog';

const PauseEmailsConfirmDialog = props => {
  const { show, proceed, dismiss, message } = props;

  const proceedHandler = useCallback((value) => {
    proceed(value);
    UxHelpers.overflowLock('unlock');
  }, [proceed]);

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={() => { proceedHandler('') }}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Pause all jobs emails"
      />
      <BasicButton
        controlFunc={() => proceedHandler('keepWeeklyDigest')}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Receive jobs digest once weekly"
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <p style={{ textAlign: 'center', fontWeight: '500', maxWidth: '500px' }}>
        {message}
      </p>
      <div className={'pause-email-dialog__radio'}>
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ proceed, dismiss }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(PauseEmailsConfirmDialog));
